module.exports = __webpack_public_path__ + "img/sign-error.60ef70c7.svg";